// Copyright 2016 Sorama B.V.

import { Color } from "services/Color/Color";
import { IColorMap } from "services/ColorMap/IColorMap";

export class GrayscaleColorMap implements IColorMap {
    public get name(): string {
        return "Grayscale";
    }

    public toColorRange(count: number): Color[] {
        const colors = <Color[]>[];

        for (let i = 0; i < count; i++) {
            const value = i / (count - 1);

            colors.push(new Color(value, value, value, 1.0));
        }

        return colors;
    }

    public toColor(value: number): Color {
        return new Color(value, value, value, 1.0);
    }
}
